<template>
  <div>
    <b-modal
      :id="`modal-action-${action}`"
      :ref="`modal-action-${action}`"
      :title="`${title} documento`"
      no-close-on-backdrop
      :ok-title="title"
      cancel-title="Cancelar"
      @ok="commitAction"
      @cancel="cancelProcess"
      size="lg"
    >
      <div class="-mt-2">
        <form
          autocomplete="off"
          data-vv-scope="sign-document"
          class="d-flex justify-content-between mt-4"
          v-on:submit.prevent
        >
          <vs-select
            class="w-50 mb-3"
            autocomplete
            label="Seleccione tipo de Firma"
            v-model="signType"
          >
            <vs-select-item
              :value="firma"
              :text="providerName(firma.proveedor)"
              v-for="firma in userSignConfiguration.userSigns"
              :key="firma.id"
            />
          </vs-select>
          <vs-input
            autocomplete="off"
            v-if="signerProviderConfig.otp"
            class=" ml-2 w-50"
            label="Código OTP"
            maxlength="6"
            name="otp"
            v-model="otpCode"
            v-validate="'required'"
            :danger="errors.has('sign-document.otp')"
            :danger-text="errors.first('sign-document.otp')"
          />
          <vs-input
            autocomplete="off"
            v-if="signerProviderConfig.password"
            class="col-12"
            type="password"
            label="Contraseña de certificado"
            name="certificatePassword"
            v-model="certificatePassword"
            v-validate="'required|min:6'"
            :danger="errors.has('sign-document.certificatePassword')"
            :danger-text="errors.first('sign-document.certificatePassword')"
          />
        </form>
      </div>
    </b-modal>
    <b-modal
      :id="`modal-action-${action}-agile`"
      :ref="`modal-action-${action}-agile`"
      :title="`${title} documento`"
      :ok-title="title"
      no-close-on-backdrop
      cancel-title="Cancelar"
      @ok="commitActionAgile"
      @cancel="cancelProcess"
      size="sm"
    >
      <form
        autocomplete="off"
        data-vv-scope="sign-document-agile"
        class="d-flex justify-content-center"
        v-on:submit.prevent
      >
        <div class="container">
          <div class="row">
            <div class="col-12">
              <p>
                Se ha enviado un código de seguridad a tu dirección de correo electrónico.
                Por favor, revisa tu bandeja de entrada.
                El correo contendrá un código de seguridad único
                que deberás ingresar para completar el proceso de registro.
              </p>
              <p>
                Si no encuentras el correo electrónico en tu bandeja de entrada,
                te recomendamos verificar la carpeta de correo no deseado (spam).
              </p>
              <p>
                Recuerda que el código de seguridad es personal y confidencial.
                No lo compartas con nadie y asegúrate de ingresarlo correctamente.
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group d-flex justify-content-center">
                <OtpInput
                  v-model="otpCode"
                  @complete="commitActionAgile"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';
import {
  VBToggle,
  BModal,
  VBModal
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';

import {
  signerProviderConfigs
} from '@/febos/chile/approvals/components/trays/managementTray/constants';
import OtpInput from '@/components/inputs/OtpInput';

export default {
  components: {
    BModal,
    OtpInput
  },
  data() {
    return {
      error: {
        message: ''
      },
      otpCode: '',
      signType: '',
      certificatePassword: '',
      signerProviderConfigs,
      signerProviderConfig: {},
      metadata: {}
    };
  },
  watch: {
    signType(sign) {
      this.$emit('selectedSign', sign);
      this.configActiveSigner();
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'userSignConfiguration'
    ]),
    providerName() {
      return (provider) => this.signerProviderConfigs[provider]?.description || provider;
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'signAttachmentFlow'
    ]),
    cancelProcess() {
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async signDocument() {
      const isValid = await this.validateForm('sign-document');
      if (!isValid) {
        return;
      }
      const sign = this.getSign();
      if (this.signerProviderConfig.coordenadas) {
        if (!(sign.y >= 0 && sign.x >= 0)) {
          this.$bvToast.toast(
            'No has colocado la ubicación de la estampa',
            {
              title: '¡Oops!',
              variant: 'warning',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 4000,
            }
          );
          return;
        }
      }

      const body = {
        adjuntoUrlS3: this.attachment.url,
        febosId: this.attachment.id,
        idExterno: this.$route.params.flowId,
        codigoAutenticador: this.otpCode,
        passwordCertificado: 'na',
        remplazarS3: true,
        tipoFirma: this.signType.tipo,
        tipo: 'firmar_adjunto_aprobaciones',
        idFirma: this.signType.id,
        OTP: this.otpCode,
        pagina: sign.page,
        // eslint-disable-next-line radix
        y: Math.floor(sign.y),
        x: Math.floor(sign.x),
      };
      if (this.signType.proveedor === signerProviderConfigs.FirmadorMinisterioEconomia.key) {
        delete body.coordenadaY;
        delete body.coordenadaX;
        delete body.paginaFirma;
      }

      if (this.signType.proveedor === signerProviderConfigs.SAgile.key) {
        body.noRedirectOnEnd = true;
      } else if (this.signType.proveedor === signerProviderConfigs.ASignAPI.key) {
        if (!this.signerProviderConfig.otp) {
          body.noRedirectOnEnd = true;
        }
      } else if (this.signType.proveedor === signerProviderConfigs.S_SignAPI_E.key) {
        body.noRedirectOnEnd = true;
      }
      const response = await this.signAttachmentFlow(body);
      if (this.signType.proveedor === signerProviderConfigs.SAgile.key) {
        this.otpCode = '';
        this.$refs[`modal-action-${this.action}-agile`].show();
        this.meta.challegeId = response.meta.challegeId;
        this.meta.transaccionId = response.meta.transaccionId;
        this.meta.validacionCode = response.meta.transaccionId;
      } else if (this.signType.proveedor === signerProviderConfigs.ASignAPI.key) {
        this.otpCode = '';
        this.$refs[`modal-action-${this.action}-agile`].show();
        this.meta = {
          ...response.meta
        };
      } else if (this.signType.proveedor === signerProviderConfigs.S_SignAPI_E.key && response.meta && response.meta.otpId) {
        this.otpCode = '';
        this.meta = {
          otpId: response.meta.otpId
        };
        this.$refs[`modal-action-${this.action}-agile`].show();
      } else {
        this.$bvToast.toast(
          `${response.mensaje}`,
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }
    },
    async signDocumentAgile() {
      const isValid = await this.validateForm('sign-document');
      if (!isValid) {
        return;
      }
      const sign = this.getSign();
      if (this.signerProviderConfig.coordenadas) {
        if (!sign.y || !sign.x) {
          this.$bvToast.toast(
            'No has colocado la ubicación de la estampa',
            {
              title: '¡Oops!',
              variant: 'warning',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 4000,
            }
          );
          return;
        }
      }
      this.meta.OTP = this.otpCode;
      this.meta.otpCode = this.otpCode;
      const body = {
        adjuntoUrlS3: this.attachment.url,
        febosId: this.attachment.id,
        idExterno: this.$route.params.flowId,
        codigoAutenticador: this.otpCode,
        passwordCertificado: 'na',
        remplazarS3: true,
        tipoFirma: this.signType.tipo,
        tipo: 'firmar_adjunto_aprobaciones',
        idFirma: this.signType.id,
        OTP: this.otpCode,
        pagina: sign.page,
        // eslint-disable-next-line radix
        y: parseInt(sign.y),
        x: sign.x,
        meta: this.meta
      };
      const response = await this.signAttachmentFlow(body);
      this.$bvToast.toast(
        `${response.mensaje}`,
        {
          title: '¡Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
    },
    commitAction(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.signDocument();
    },
    commitActionAgile(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.signDocumentAgile();
    },
    configActiveSigner() {
      if (this.signType && this.signType.proveedor) {
        this.signerProviderConfig = this.signerProviderConfigs[this.signType.proveedor];
        if (this.signerProviderConfig.configureOnSelect) {
          this.signerProviderConfig.configureOnSelect(this.signType, this.signerProviderConfig);
        }
      } else {
        this.signerProviderConfig = {};
      }
    }
  },
  mounted() {
    this.signerProviderConfig = {};
    this.meta = {};
    const [signSelected] = this.userSignConfiguration.userSigns;
    const segPresSign = this.userSignConfiguration.userSigns.find((sign) => sign.proveedor.includes('Segpres'));
    if (segPresSign) {
      this.signType = segPresSign;
    } else {
      this.signType = signSelected;
    }
  },
  props: {
    action: { type: String, required: true },
    attachment: { type: Object, required: true },
    title: { type: String, required: true },
    stepId: { type: Object, required: false },
    getSign: Function,
    numPages: Number
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
    'b-modal': VBModal
  },
};
</script>
